import DiagnosticPanel from './components/DiagnosticPanel';
import React from "react";
import Routes from "./Routes";

function App() {
  return (
    <>
      <DiagnosticPanel />
      <Routes />
    </>
  );
}


export default App;
